import axios from 'axios';

// Same-origin "/api" in dev (CRA proxy); set REACT_APP_API_URL in .env.production
// when the API lives on its own domain, e.g. https://rcg.ceynexlk.com/api
export const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

const api = axios.create({ baseURL: API_BASE });

// Admin and member sessions are stored separately so both can be open at once
const tokenKey = url => (url?.startsWith('/admin') ? 'adminToken' : 'memberToken');

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem(tokenKey(cfg.url));
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res,
  err => {
    const url = err.config?.url || '';
    if (err.response?.status === 401 && !url.endsWith('/login') && url !== '/public/login') {
      if (url.startsWith('/admin')) {
        localStorage.removeItem('adminToken');
        if (!window.location.pathname.startsWith('/admin/login')) window.location.href = '/admin/login';
      } else if (url.startsWith('/member')) {
        localStorage.removeItem('memberToken');
        if (window.location.pathname !== '/login') window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (err, fallback = 'Something went wrong') => err?.response?.data?.error || fallback;

// Blob errors come back as Blob — decode them for a readable message
export async function blobErrMsg(err, fallback) {
  try {
    const text = await err.response.data.text();
    return JSON.parse(text).error || fallback;
  } catch {
    return fallback;
  }
}

export async function downloadFile(url, filename, params) {
  const res = await api.get(url, { responseType: 'blob', params });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}

export async function openFile(url) {
  const win = window.open('', '_blank');
  const res = await api.get(url, { responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  if (win) win.location.href = href;
  else window.location.href = href;
}

export default api;
